import Picker from '../picker'
import DatePanel from '../panel/date'
import DateRangePanel from '../panel/date-range'
import MonthRangePanel from '../panel/month-range'
import DateTimeRange from '../panel/date-time-range.vue'

const getPanel = function(type) {
  if (type === 'daterange') {
    return DateRangePanel
  } else if (type === 'monthrange') {
    return MonthRangePanel
  } else if (type === 'datetimerange') {
    return DateTimeRange
  }
  return DatePanel
}

export default {
  mixins: [Picker],

  name: 'KyeDatePicker2',

  props: {
    type: {
      type: String,
      default: 'date'
    },
    timeArrowControl: Boolean,
    // 显示农历
    showLunar: {
      type: Boolean,
      default: true
    }
  },

  watch: {
    type(type) {
      if (this.picker) {
        this.unmountPicker()
        this.panel = getPanel(type)
        this.mountPicker()
      } else {
        this.panel = getPanel(type)
      }
    }
  },

  created() {
    this.panel = getPanel(this.type)
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-date-picker2/src/picker/date-picker.js